<template>
    <div class="action-buttons">
        <button class="alternate-button" v-if="step > 0" @click="prev_step"><trans msg="prev_button" /></button>
        <button v-if="step < 5 && step > 0" @click="next_step"><trans msg="next_button" /></button>
        <button v-if="step === 0" @click="next_step"><trans msg="step0_button" /></button>
        <button v-if="step === 5" @click="next_step"><trans msg="step5_button" /></button>
    </div>
</template>

<script>

import Translation from './Translation.vue'

export default {
  name: 'action-buttons',
  props: ['step'],
  methods: {
    next_step: function() {
        if(this.step < 6) {
            this.$emit('step', this.step + 1);
        }
    },
    prev_step: function() {
        if(this.step > 0) {
            this.$emit('step', this.step - 1);
        }
    }
  },
  components: {
    'trans': Translation
  }
}
</script>

<style scoped>
    .action-buttons {
        position: absolute;
        bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// Buttons.vue?56e458ed